<template>
  <svg
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    :width="props.size"
    :height="props.size"
    :viewBox="`0 0 24 24`"
    :fill="props.fill"
    :stroke="props.stroke"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "24",
  },
  fill: {
    type: String,
    default: "none",
  },
  stroke: {
    type: String,
    default: "currentColor",
  },
  strokeWidth: {
    type: String,
    default: "1",
  },
});
</script>
